import { useEffect, useRef, useState } from "react";
import MastercardLogo from "./logoMasterCard";
import VisaLogo from "./logoVisa";


const detectNetwork = (number) => {
  const n = number.replace(/\s/g, "");
  if (/^4/.test(n)) return "visa";
  if (/^5[1-5]/.test(n)) return "mastercard";
  return null;
};



// Red Mastercard
const NetworkToggle = () => {
  const [showVisa, setShowVisa] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowVisa((prev) => !prev);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ position: "relative", width: "50px", height: "32px" }}>
      <style>{`
        @keyframes fade-in-net { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fade-out-net { from { opacity: 1; transform: translateY(0); } to { opacity: 0; transform: translateY(4px); } }
        .net-enter { animation: fade-in-net 0.35s ease forwards; }
        .net-exit  { animation: fade-out-net 0.35s ease forwards; }
      `}</style>

      {/* Visa */}
      <div
        key={`visa-${showVisa}`}
        className={showVisa ? "net-enter" : "net-exit"}
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <VisaLogo />
      </div>

      {/* Mastercard */}
      <div
        key={`mc-${showVisa}`}
        className={!showVisa ? "net-enter" : "net-exit"}
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <MastercardLogo size={32} />
      </div>
    </div>
  );
};

const AnimatedCard = ({
  cardNumber,
  expiry,
  cvc,
  isFlipped,
  holderName = "PEDRO PEREZ",
}) => {
  const detectedNetworkRef = useRef(null);

  const currentNetwork = detectNetwork(cardNumber);

  if (currentNetwork && currentNetwork !== detectedNetworkRef.current) {
    detectedNetworkRef.current = currentNetwork;
  }
  const network = detectedNetworkRef.current;

  // Número enmascarado: muestra X en los primeros 12 y los últimos 4 reales
  const raw = cardNumber.replace(/\s/g, "");
  const masked =
    raw.length > 0
      ? [
          raw.length > 0 ? raw.slice(0, 4).padEnd(4, "X") : "XXXX",
          raw.length > 4 ? raw.slice(4, 8).padEnd(4, "X") : "XXXX",
          raw.length > 8 ? raw.slice(8, 12).padEnd(4, "X") : "XXXX",
          raw.length > 12 ? raw.slice(12, 16).padEnd(4, "X") : "XXXX",
        ].join(" - ")
      : "XXXX - XXXX - XXXX - XXXX";

  // Chip realista
  const ChipIcon = () => (
    <div
      style={{
        width: "46px",
        height: "36px",
        borderRadius: "6px",
        background:
          "linear-gradient(145deg, #e8c84a, #c9a227, #f5d76e, #b8941f)",
        position: "relative",
        overflow: "hidden",
        boxShadow:
          "inset 0 1px 2px rgba(255,255,255,0.4), 0 2px 4px rgba(0,0,0,0.3)",
      }}
    >
      <style>{`
      @keyframes chip-shine {
        0%   { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
        100% { transform: translateX(200%) translateY(200%) rotate(45deg); }
      }
    `}</style>

      {/* Líneas horizontales */}
      {[28, 42, 56, 70, 84].map((pct, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: `${pct}%`,
            height: "1px",
            background: "rgba(120,80,0,0.35)",
          }}
        />
      ))}
      {/* Líneas verticales */}
      {[28, 72].map((pct, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: `${pct}%`,
            width: "1px",
            background: "rgba(120,80,0,0.35)",
          }}
        />
      ))}
      {/* Centro */}
      <div
        style={{
          position: "absolute",
          top: "25%",
          left: "22%",
          width: "56%",
          height: "50%",
          borderRadius: "3px",
          background: "linear-gradient(135deg, #d4a827, #f0c840)",
          border: "1px solid rgba(120,80,0,0.3)",
        }}
      />
      {/* Reflejo estático */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "40%",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.25), transparent)",
          borderRadius: "6px 6px 0 0",
        }}
      />
      {/* ✨ Luz deslizante en diagonal */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "30px",
          height: "120px",
          background:
            "linear-gradient(to bottom right, transparent 30%, rgba(255,255,255,0.45) 50%, transparent 70%)",
          animation: "chip-shine 2.8s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />
    </div>
  );

  const NetworkLogo = () => (
    <>
      {network === "visa" && <VisaLogo />}
      {network === "mastercard" && <MastercardLogo size={32} />}
      {!network && <NetworkToggle />}
    </>
  );

  return (
    <div
      style={{
        perspective: "1200px",
        width: "320px",
        height: "195px",
        margin: "0 auto",
      }}
    >
      <style>{`
        .card-inner {
          position: relative; width: 100%; height: 100%;
          transition: transform 0.65s cubic-bezier(0.4, 0, 0.2, 1);
          transform-style: preserve-3d;
        }
        .card-inner.flipped { transform: rotateY(180deg); }
        .card-face {
          position: absolute; width: 100%; height: 100%;
          backface-visibility: hidden; -webkit-backface-visibility: hidden;
          border-radius: 18px;
        }
        .card-back { transform: rotateY(180deg); }
      `}</style>

      <div className={`card-inner ${isFlipped ? "flipped" : ""}`}>
        {/* ── FRENTE ─────────────────────────────────────────────── */}
        <div
          className="card-face"
          style={{
            background:
              "linear-gradient(135deg, #160d3a 0%, #2d1b6e 40%, #4a1a8f 75%, #6b1fa8 100%)",
            padding: "18px 22px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            boxShadow:
              "0 24px 48px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.06)",
          }}
        >
          {/* Fondo brillo sutil */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              width: "60%",
              height: "100%",
              borderRadius: "18px",
              background:
                "radial-gradient(ellipse at top right, rgba(168,85,247,0.25) 0%, transparent 65%)",
              pointerEvents: "none",
            }}
          />

          {/* Top: Chip + Network */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              position: "relative",
              zIndex: 1,
            }}
          >
            <ChipIcon />
            {/* Network logo */}
            <NetworkLogo />
          </div>

          {/* Número enmascarado */}
          <div
            style={{
              letterSpacing: "2.5px",
              fontSize: "14px",
              color: "#fff",
              fontFamily: "'Courier New', monospace",
              fontWeight: 700,
              position: "relative",
              zIndex: 1,
              textShadow: "0 1px 3px rgba(0,0,0,0.4)",
            }}
          >
            {masked}
          </div>

          {/* Bottom: Nombre + Fecha + Logo Galilea */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div>
              <p
                style={{
                  color: "rgba(255,255,255,0.5)",
                  fontSize: "8px",
                  letterSpacing: "1.5px",
                  margin: "0 0 3px",
                  fontFamily: "monospace",
                }}
              >
                TITULAR
              </p>
              <p
                style={{
                  color: "#fff",
                  fontSize: "13px",
                  fontWeight: 700,
                  margin: 0,
                  letterSpacing: "1px",
                  fontFamily: "monospace",
                }}
              >
                {holderName.toLocaleUpperCase() || "NOMBRE APELLIDO"}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: "6px",
              }}
            >
              <div style={{ textAlign: "right" }}>
                <p
                  style={{
                    color: "rgba(255,255,255,0.5)",
                    fontSize: "8px",
                    letterSpacing: "1.5px",
                    margin: "0 0 2px",
                    fontFamily: "monospace",
                  }}
                >
                  VENCE
                </p>
                <p
                  style={{
                    color: "#fff",
                    fontSize: "13px",
                    fontFamily: "monospace",
                    fontWeight: 700,
                    margin: 0,
                  }}
                >
                  {expiry || "MM/AA"}
                </p>
              </div>
              {/* Logo Galilea — bottom right */}
              {/* <img
                src="/svg/imagotipo-galilea-20.svg"
                style={{ marginTop: "8px" }}
                alt="Galilea"
              /> */}
            </div>
          </div>
        </div>

        {/* ── REVERSO ────────────────────────────────────────────── */}
        <div
          className="card-face card-back"
          style={{
            background:
              "linear-gradient(135deg, #160d3a 0%, #2d1b6e 50%, #4a1a8f 100%)",
            boxShadow:
              "0 24px 48px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.06)",
            display: "flex",
            flexDirection: "column",
            padding: "18px 22px",
            overflow: "hidden",
          }}
        >
          {/* Top reverso: Logo Galilea */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              position: "relative",
              zIndex: 1,
            }}
          >
            {/* <img
              src="/svg/imagotipo-galilea-20.svg"
              style={{ width: "30px", height: "30px" }}
              alt="Galilea"
            /> */}
            <NetworkLogo />
          </div>

          {/* Banda magnética */}
          <div
            style={{
              width: "100%",
              height: "42px",
              background: "linear-gradient(180deg, #0a0a14, #111122, #0a0a14)",
              marginTop: "10px",
              boxShadow:
                "0 2px 6px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.05)",
            }}
          />

          {/* Firma + CVC */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flex: 1,
            }}
          >
            {/* Panel de firma */}
            <div
              style={{
                flex: 1,
                height: "36px",
                background:
                  "repeating-linear-gradient(45deg, #e8e4f0, #e8e4f0 4px, #d0cce0 4px, #d0cce0 8px)",
                borderRadius: "4px",
                border: "1px solid rgba(255,255,255,0.1)",
              }}
            />
            {/* Caja CVC */}
            <div
              style={{
                minWidth: "58px",
                height: "36px",
                background: "rgba(240, 236, 255, 0.95)",
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "inset 0 1px 3px rgba(0,0,0,0.15)",
              }}
            >
              <span
                style={{
                  color: "#1a1a2e",
                  fontFamily: "'Courier New', monospace",
                  fontWeight: 800,
                  fontSize: "15px",
                  letterSpacing: "3px",
                }}
              >
                {cvc || "•••"}
              </span>
            </div>
          </div>

          <p
            style={{
              color: "rgba(255,255,255,0.35)",
              fontSize: "9px",
              textAlign: "center",
              margin: "0 0 10px",
              letterSpacing: "1px",
            }}
          >
            CVC / CVV
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnimatedCard;
